import React from 'react';
import css from "./NoSurveys.css";
import { SFSurveysTenantLanguage } from "utils/types";

export default class NoSurveys extends React.PureComponent {

    render() {

        return (

            <div className={css['container']}>
                <img src="../images/starfish/thumbsup.png"  aria-hidden="true"
                     className={css['image']}/>
                <div  className={css['text']}>
                    <h1 tabIndex={0}>{`You have no ${this.props.progressSurveyWords.plural.surveys} to complete at this time`}</h1>
                </div>
            </div>
        )
    }

}

NoSurveys.propTypes = {
  progressSurveyWords: SFSurveysTenantLanguage
};
